export default __webpack_public_path__ + "static/media/css3-alt-brands.d9bd7995.svg";